export const GENERAL_FORM_MINIMUM_TEXT_LENGTH = 2;
export const GENERAL_FORM_EXTENDED_MINIMUM_TEXT_LENGTH = 4;

export const GENERAL_FORM_ZIP_CODE_LENGTH = 5;

export const RELATIONSHIP_TO_CLIENT_OPTIONS = [
  { value: 'Mother', label: 'Mother' },
  { value: 'Father', label: 'Father' },
  { value: 'Legal Guardian', label: 'Legal Guardian' },
  { value: 'Adoptive Parent', label: 'Adoptive Parent' },
  { value: 'Foster Parent', label: 'Foster Parent' },
  { value: 'Step-Mother', label: 'Step-Mother' },
  { value: 'Step-Father', label: 'Step-Father' },
  { value: 'Grandmother', label: 'Grandmother' },
  { value: 'Grandfather', label: 'Grandfather' },
  { value: 'Aunt', label: 'Aunt' },
  { value: 'Uncle', label: 'Uncle' },
  { value: 'Sibling (Brother / Sister)', label: 'Sibling (Brother / Sister)' },
  { value: 'Half-Sibling', label: 'Half-Sibling' },
  { value: 'Cousin', label: 'Cousin' },
  { value: 'Nanny / Babysitter', label: 'Nanny / Babysitter' },
  { value: 'Caregiver', label: 'Caregiver' },
  { value: 'Family Friend', label: 'Family Friend' },
  { value: 'Case Worker / Social Worker', label: 'Case Worker / Social Worker' },
  { value: 'Court-Appointed Guardian', label: 'Court-Appointed Guardian' },
] as const;
